<template>
  <PageHeader :title="$t('ui.common.company')">
    <template #right></template>
  </PageHeader>
</template>

<script setup>
import PageHeader from '@/components/page/PageHeader.vue'
</script>

<style></style>
